import classNames from 'classnames';
import { graphql } from 'gatsby';
import React from 'react';
import Link from '~/components/Common/Link';

export const query = graphql`
	fragment FileListFragment on Ozk_content_blockModular_blocksCopyContent {
		file_list {
			list_type
			files {
				label
				external_link
				open_in_new_tab
				file {
					...AssetFragment
				}
			}
		}
	}
`;

/**
 * @typedef {'none' | 'bullet' | 'letter' | 'checkmark'} ListType
 *
 * @typedef FileInList
 * @property {string} label The label of the file in the list.
 * @property {string} [external_link] The link to visit for download.
 * @property {boolean} open_in_new_tab A value indicating whether the link opens in the new tab.
 * @property {import('../CSTypes').CSFile} [file] The file to download.
 *
 * @typedef FileListOptions
 * @property {ListType} list_type The type to display the list as.
 * @property {FileInList[]} files The files to render.
 *
 * @typedef FileListProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<FileListOptions>} options
 */
/** @type {import('~/types/React').ReactFC<FileListProps>} */
const FileList = ({ options }) => {
	// Throw an error if a file list item is misconfigured.
	const bad = options.files.find((f) => !f.file && !f.external_link);
	if (!!bad) {
		throw new Error(`Missing file link for File List item: ${bad.label}`);
	}

	return (
		<ul className={classNames('file-list', options.list_type)} {...options.$?.list_type}>
			{options.files?.map((f, i) => (
				<li key={i}>
					<Link to={f.file?.url ?? f.external_link ?? 'bad url'} openInNewTab={f.open_in_new_tab}>
						{f.label}
					</Link>
				</li>
			))}
		</ul>
	);
};
export default FileList;
